import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueKonva from 'vue-konva'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import { router } from './app/router'

const app = createApp(App)

// ── Sentry ──────────────────────────────────────────────────────────────────
const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
if (sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.05,
    sendDefaultPii: false,
  })
}

app.use(createPinia())
app.use(router)
app.use(VueKonva)

app.mount('#app')
